import { ErrorMessage } from 'ng-bootstrap-form-validation';

export const CUSTOM_ERRORS: ErrorMessage[] = [
	{
		error: 'required',
		format: requiredFormat
	}, {
		error: 'email',
		format: emailFormat
	}, {
		error: 'pattern',
		format: emailFormat
	}, {
		error: 'minlength',
		format: minLengthFormat
	}, {
		error: 'maxlength',
		format: maxLengthFormat
	}
];

export function requiredFormat(label: string, error: any): string {
	return `${label} è un campo obbligatorio!`;
}

export function emailFormat(label: string, error: any): string {
	return `${label}. Formato errato!`;
}

export function patternFormat(label: string, error: any): string {
	return `${label}. Formato errato!`;
}

export function minLengthFormat(label: string, error: any): string {
	return `${label}. Lunghezza minima non raggiunta!`;
}

export function maxLengthFormat(label: string, error: any): string {
	return `${label}. Lunghezza massima superata!`;
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/custom-global-errors.ts